import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import { SlideInPanelAnchorLocation } from "@redotech/redo-model/slide-in-panel/slide-in-panel-anchor-location";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useState } from "react";
import { ExtensionShopifyClientContext } from "../../../../shopify";
import { SlideInPanel } from "../../../slide-in-panel/slide-in-panel";
import { useLoyaltyInfo } from "../use-loyalty-info";
import { LoggedInLoyaltyPopup } from "./logged-in-popup";
import { LoggedOutLoyaltyPopup } from "./logged-out-popup";

export const LoyaltyPopup = memo(function LoyaltyPopup({
  anchorLocation,
}: {
  anchorLocation: SlideInPanelAnchorLocation;
}) {
  const extensionShopifyClient = useRequiredContext(
    ExtensionShopifyClientContext,
  );

  const loyaltyInfo = useLoyaltyInfo();

  const [panelOpen, setPanelOpen] = useState(true);

  const closePanel = useHandler(() => {
    setPanelOpen(false);
  });

  return (
    <SlideInPanel
      anchorLocation={anchorLocation}
      handleCloseClick={closePanel}
      open={panelOpen}
    >
      <Flex dir="column" pt="xl" w="full">
        {loyaltyInfo.loggedIn ? (
          <LoggedInLoyaltyPopup
            loyaltyInfo={loyaltyInfo}
            readonly={false}
            redeemPoints={async (pointsToUse: number) => {
              // TODO: redeem points and retrieve discount code
              await extensionShopifyClient.applyDiscountCode?.("test");
            }}
          />
        ) : (
          <LoggedOutLoyaltyPopup loyaltyInfo={loyaltyInfo} />
        )}
      </Flex>
    </SlideInPanel>
  );
});
